const Abbreviations = {
  INITIAL_CATEGORY: "initialCategory",
  INITIAL_VIDEOS: "initialVideos",
  SORT_BY: "sortBy",
  LOGOUT: "logout",
  LIKE_VIDEO: "likeVideo",
  WATCH_LATER: "watchLater",
  ADD_TO_HISTORY: "addToHistory",
  CREATE_PLAYLIST :"createPlaylist",
  UPDATE_VIDEO_PLAYLIST :'updatePlaylist',
  SEARCH_VIDEOS:"searchVideos",
  SORT_BY_DATE: 'sortByDate',
};
export { Abbreviations };
